import { createReducer, on } from '@ngrx/store';
import { resetPassword, resetPasswordSuccess, resetPasswordFailure } from './reset.actions';

export interface State {
  readonly error: string | null;
  readonly pending: boolean;
}

export const initialState: State = {
  error: null,
  pending: false,
};

export const reducer = createReducer(
  initialState,

  on(resetPassword, (state) => ({
    ...state,
    error: null,
    pending: true,
  })),

  on(resetPasswordSuccess, (state) => ({
    ...state,
    error: null,
    pending: false,
  })),

  on(resetPasswordFailure, (state, { payload }) => ({
    ...state,
    error: payload,
    pending: false,
  }))
);

export const getError = (state: State) => {
  return state.error;
};
export const getPending = (state: State) => {
  return state.pending;
};
